import { useEffect } from 'react'
import { useNavigate, useParams } from '@tanstack/react-router'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import { Loader } from 'lucide-react'
import {
  createLiveEvent,
  fetchLiveEvent,
  updateLiveEvent,
} from 'store/liveEvents/liveEventsSlice'
import { useAppDispatch, useAppSelector } from 'store/store'
import LiveEventForm from 'ui/components/LiveEventForm'

/** Create (`/eventi-live/nuovo`) and edit (`/eventi-live/$id/modifica`). */
const LiveEventFormPage = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { id } = useParams({ strict: false }) as { id?: string }
  const eventId = id ? parseInt(id, 10) : null
  const { event, loading, saving } = useAppSelector((s) => s.liveEvents)

  useEffect(() => {
    if (eventId) dispatch(fetchLiveEvent(eventId))
  }, [dispatch, eventId])

  const editing = eventId != null
  const ready = !editing || (event?.id === eventId && !loading)

  return (
    <>
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>
      <Main>
        <div className='mb-4'>
          <h2 className='text-2xl font-bold tracking-tight'>
            {editing
              ? `Modifica ${event?.name ?? 'evento'}`
              : 'Nuovo evento live'}
          </h2>
          <p className='text-muted-foreground'>
            Dati dell'evento, brand (logo e tre colori) e difficoltà del gioco.
          </p>
        </div>
        {!ready ? (
          <Loader className='h-5 w-5 animate-spin' />
        ) : (
          <LiveEventForm
            // remount when the loaded event changes, so the form starts from it
            key={event?.id ?? 'new'}
            event={editing ? event : null}
            saving={saving}
            onSubmit={async (input) => {
              const action = editing
                ? await dispatch(updateLiveEvent({ id: eventId, input }))
                : await dispatch(createLiveEvent(input))
              if (
                createLiveEvent.fulfilled.match(action) ||
                updateLiveEvent.fulfilled.match(action)
              ) {
                navigate({
                  to: '/eventi-live/$id',
                  params: { id: action.payload.id.toString() },
                })
              }
            }}
          />
        )}
      </Main>
    </>
  )
}

export default LiveEventFormPage
